/**
 * Sticky header scroll shadow + nav height CSS custom property.
 */
const initStickyHeader = () => {
  const header = document.querySelector( '.site-header' );

  if ( ! header ) {
    return;
  }

  const setNavHeight = () => {
    document.documentElement.style.setProperty( '--nav-height', `${header.offsetHeight}px` );
  };

  setNavHeight();
  window.addEventListener( 'resize', setNavHeight, { passive: true } );

  window.addEventListener( 'scroll', () => {
    header.classList.toggle( 'is-scrolled', window.scrollY > 10 );
  }, { passive: true } );
};

export default initStickyHeader;
